export module FeatureHelper {

    export const Supports = (feature: string, features: string[]) => { 
        return features && features.indexOf(feature) > -1;
    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/features.ts